import { queryOptions, useQuery } from '@tanstack/react-query'

import { getApi, unwrap } from '@/api/client'
import { qk } from '@/api/query-keys'
import type { McpExportSettings } from '@/api/types'

/**
 * Where exported files land, and for how long their links work.
 *
 * Opted out of the global error handler: the section simply drops when no
 * bucket is configured, which is not a failure worth interrupting anybody for.
 */
export function mcpExportSettingsQuery() {
  return queryOptions({
    queryKey: qk.mcpExportSettings(),
    retry: false,
    meta: { skipGlobalErrorHandler: true },
    queryFn: (): Promise<McpExportSettings> =>
      unwrap(getApi().GET('/api/database/mcp/export-settings/')),
  })
}

export function useMcpExportSettings() {
  return useQuery(mcpExportSettingsQuery())
}
